export default __webpack_public_path__ + "static/media/stocks.ad330ee4.svg";